import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * Loading state shown while a workspace/layout is still resolving — before we
 * know (or have) the real panel arrangement.
 *
 * Deliberately EMPTY: bare background plus the standard small spinner in the
 * top-left. It previously drew a single full-area placeholder panel, which was
 * indistinguishable from a real (empty) chart panel — so a hold read as "the app
 * loaded my layout wrong" rather than "the app is loading". Anything panel-shaped
 * here implies structure we do not have yet.
 *
 * `withToolbar` is retained for call-site compatibility (the full-page gates pass
 * it) but no longer changes the output: with nothing but a spinner there is no
 * toolbar to approximate.
 */
export function WorkspaceSkeleton({
  withToolbar: _withToolbar = false,
  className,
}: {
  withToolbar?: boolean
  className?: string
}) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading workspace"
      className={cn('h-full w-full bg-background p-3', className)}
    >
      <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
    </div>
  )
}
